import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config/api';

const API = API_URL;

const AnnouncementBar = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  // Hide on Page Builder Studio routes
  const isPageBuilderStudio = location.pathname.includes('/admin/page-builder/') && 
                              !location.pathname.endsWith('/page-builder');
  
  useEffect(() => {
    // Check if already dismissed in this session
    const isDismissed = sessionStorage.getItem('announcement_dismissed');
    if (isDismissed) {
      setDismissed(true);
      return;
    }

    fetchAnnouncement();
  }, []);

  const fetchAnnouncement = async () => {
    try {
      const response = await axios.get(`${API}/site/settings`);
      const announcementData = response.data.announcement_bar;
      
      if (announcementData && announcementData.enabled && announcementData.text) {
        setAnnouncement(announcementData);
      }
    } catch (error) {
      console.error('Failed to fetch announcement:', error);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('announcement_dismissed', 'true');
  };

  if (dismissed || !announcement || isPageBuilderStudio) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white relative">
      <div className="max-w-7xl mx-auto px-4 py-2 text-center">
        <p className="text-sm font-medium pr-8">
          {announcement.text}
          {announcement.link && (
            announcement.link.startsWith('/') ? (
              <Link to={announcement.link} className="ml-2 underline hover:no-underline">
                Learn more →
              </Link>
            ) : (
              <a 
                href={announcement.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-2 underline hover:no-underline"
              >
                Learn more →
              </a>
            )
          )}
        </p>
      </div>
      <button
        onClick={handleDismiss}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Dismiss announcement"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
